import { parseSiteRegisterDate } from "./adminEditModalTheme";

export function parseSf009DateForPicker(value) {
  if (value == null || value === "") return null;
  if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
  const slashOrDash = parseSiteRegisterDate(value);
  if (slashOrDash) return slashOrDash;
  if (typeof value === "string") {
    const m = value.trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (m) {
      const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
      return isNaN(d.getTime()) ? null : d;
    }
  }
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
}

export function datePickerToSf009DateString(d) {
  if (!d || !(d instanceof Date) || isNaN(d.getTime())) return "";
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function formatSf009DateDisplay(d) {
  if (d == null || d === "") return "";
  const x = d instanceof Date ? d : parseSf009DateForPicker(d);
  if (!x || isNaN(x.getTime())) {
    return String(d).trim();
  }
  return x.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

export function formatSf009DateDisplayOrDash(d) {
  const formatted = formatSf009DateDisplay(d);
  return formatted || "—";
}
